import type { ReactNode, Ref } from 'react';
import { cn } from '~/lib/cn';

/**
 * The design's base layout grid: 9 columns with a 20px gutter (gap-5).
 * Place children with Tailwind `col-span-*` / `col-start-*` utilities so page
 * content stays aligned to the grid.
 */
export function Grid({
  className,
  children,
  ref,
}: {
  className?: string;
  children: ReactNode;
  ref?: Ref<HTMLDivElement>;
}) {
  return (
    <div ref={ref} className={cn('grid grid-cols-9 gap-5', className)}>
      {children}
    </div>
  );
}
